import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '综合搜索', to: '/search' },
  { label: '关于我们', to: '/about' },
];

const friendLinks = [
  { label: '影视资讯速递', to: '/' },
  { label: '热门剧集榜单', to: '/category/tv' },
  { label: '院线新片前瞻', to: '/category/movie' },
  { label: '影视观察专栏', to: '/' },
];

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-primary-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4 lg:py-14">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-leaf-line text-xl" />
            </span>
            <span className="font-brand text-2xl text-background-50">枫与铃</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
            枫与铃致力于提供最新的影视剧资讯和推荐，涵盖电影、电视剧等多种影视作品，帮助用户快速了解和选择喜爱的影视内容。
          </p>
          <div className="mt-5 flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-primary-100 transition-colors hover:bg-accent-500 hover:text-background-50">
              <i className="ri-wechat-line" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-primary-100 transition-colors hover:bg-accent-500 hover:text-background-50">
              <i className="ri-weibo-line" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-primary-100 transition-colors hover:bg-accent-500 hover:text-background-50">
              <i className="ri-rss-line" />
            </span>
          </div>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-background-50">站内导航</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {quickLinks.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-primary-200 transition-colors hover:text-accent-300">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-background-50">友情链接</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {friendLinks.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-primary-200 transition-colors hover:text-accent-300">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800/70">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-primary-300 md:flex-row md:px-6">
          <p>© 2025 枫与铃 · 影视剧资讯与精彩推荐　本站内容为演示示例，不提供在线播放与下载服务。</p>
          <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <span>内容均为演示数据</span>
            <span className="hidden sm:inline text-primary-700">|</span>
            <span>版权与免责声明</span>
          </p>
        </div>
      </div>
    </footer>
  );
}